import {
  TweenMax,
  TimelineMax,
  Sine,
  Linear
} from "gsap";
//  Power2, Elastic, CSSPlugin ,Tweenmax
export function play() {
  console.log('security animation')
  // set up shadows
  TweenMax.to("feDropShadow",0.3, {
    attr: {
      stdDeviation: 10
    }
  },0).repeat(-1).yoyo(true)

  TweenMax.to("feGaussianBlur",1, {
    attr: {
      stdDeviation: 10,
      ease: Linear.easeIn
    }
  },0.5).repeat(-1).yoyo(true)

  // 警車
  TweenMax.from(`[data-name='police']`, 5, {
    x: 80,
    y: 50
  }).repeat(-1).yoyo(true)

  TweenMax.set(`[data-name='police'] polygon`, {
    attr: {
      filter: "url(#dropshadow)"
    }
  })

  //消防車燈
  // TweenMax.set(`[data-name='light_fire'] polygon`, {
  //   attr: {
  //     filter: "url(#dropshadowA)"
  //   }
  // })

  // 巡邏箱
  let box = `[data-name='蓋子']`
  TweenMax.to(box,{
    transformOrigin: '0% 0% 0%',
  }).repeat(-1).yoyo(true)

  TweenMax.to(box,2,{
    scaleX: -0.1
  }).repeat(-1).yoyo(true)

  // 雷達右邊

  TweenMax.set(`[data-name='connect_building'] path, [data-name='connect_box'] path`, {
    opacity: 1
  })

  let tl = new TimelineMax()
  tl.staggerFrom(`[data-name='connect_building'] path` , 1, {
    opacity: 0,
    ease: Linear.easeNone
  }, 0.5).repeat(-1)

  // 雷達左邊
  let tl2 = new TimelineMax()
  tl2.staggerFrom(`[data-name='connect_box'] path`, 0.5, {
    opacity: 0,
    ease: Linear.easeNone
  }, 0.5)
  tl2.delay(0).repeat(-1)
}